import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js'

export function getDisplayPhoneNumber(
  phoneNumber: string,
  countryCode: CountryCode = 'TH',
) {
  const number = parsePhoneNumberFromString(phoneNumber, countryCode)
  return number?.formatNational().replace(/ /g, '-')
}
